import React, { useEffect, useState } from 'react';
import logo from '../utils/echo.png';

const Disabled = () => {
    const [countdown, setCountdown] = useState(30);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        if (countdown <= 0) {
            checkServerStatus();
            setCountdown(30);
        }
    }, [countdown]);

    const checkServerStatus = () => {
        fetch("https://api.fantasyworldtrpg.cz/echo/serveronline.php")
            .then(async (res) => {
                if (!res.ok) {
                    throw new Error("Failed to fetch status file");
                }
                const text = await res.text();
                const cleanedText = text.trim().toLowerCase();
                if (cleanedText === "online") {
                    window.location.href = "/";
                }
            })
            .catch((err) => {
                console.error("Error checking server status:", err);
            });
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            textAlign: 'center',
            padding: '20px'
        }}>
            <img src={logo} alt="Echo Logo" style={{ width: '150px', marginBottom: '20px' }} />
            <h1 style={{ fontSize: '3rem', marginBottom: '20px' }}>Echo je momentálně nedostupné</h1>
            <p style={{ fontSize: '1.5rem', marginBottom: '10px' }}>
                Zkouším znovu připojit za {countdown} sekund...
            </p>
            <p style={{ fontSize: '1rem', color: 'gray' }}>
                Jakmile bude server zpět online, automaticky tě přesměrujeme. 💖
            </p>
        </div>
    );
};

export default Disabled;
